import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin, Subject } from 'rxjs';
import { PgToolbarComponent } from 'src/app/shared/components/title-bar/title-bar.component';
import { DurationSof, ToolbarItem, Vessel, VesselsService } from '../vessels.service';
import { LoadingTimeToolbarComponent } from './loading-time-toolbar/loading-time-toolbar.component';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { UserLocalStoreService } from 'src/app/shared/services/user-local-store.service';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

interface SOFComponentSettings {
  type: string;
  sofItem1: string;
  sofItem2: string;
}
@Component({
  selector: 'app-loading-time',
  templateUrl: './loading-time.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class LoadingTimeComponent implements OnInit, PgToolbarComponent {

  toolbarComponentType = LoadingTimeToolbarComponent;
  toolbarComponent!: LoadingTimeToolbarComponent;

  title: EventEmitter<string> = new EventEmitter();

  isDataTablesInitialised = false;
  dtOptions = {};
  dtTrigger: Subject<any> = new Subject<any>();
  sofItems!: DurationSof[];
  ports!: Organisation[];
  vesselImo!: string;
  moment = moment;
  lookUpSofItems!: string[][];
  selectSofItems!: [string, string, string];
  sofItem1!: string;
  sofItem2!: string;
  sofName1!: string;
  sofName2!: string;
  toolTip1!: string;
  toolTip2!: string;
  dateRange = {
    startDate : moment(new Date()).subtract(365, 'days').toDate(),
    endDate: new Date()
  };
  startDate!: number;
  endDate!: number;
  vessels: Vessel[] = [];
  _settings!: SOFComponentSettings;

  gridOptions: GridOptions = {};

  private _type!: string;
  constructor(private _vesselsService: VesselsService,
    private _organisationService: OrganisationService,
    private _lookupServiceSpa: LookupServiceSpa,
    private _userLocalStorage: UserLocalStoreService
  ) { }

  columnDefs = [
    {headerName:'Vessel Name', field:'vesselName'},
    {headerName:'IMO', field:'vesselImo'},

    {headerName:'Voyage NO', field:'shipVoyageNo'},

    {headerName:'port', field:'portOrganisationId',
      cellRenderer: (row: ICellRendererParams) => this.formatPorts(row.value)
    },
    {headerName:'NOR Tendered', field:'',
      cellRenderer: (row: ICellRendererParams) => this.dateTime(row.data.portOrganisationId, row.data.startTime)
    },
    {headerName:'Cargo arm Disconnected', field:'',
      cellRenderer: (row: ICellRendererParams) => this.dateTime(row.data.portOrganisationId, row.data.endTime)
    },
    {headerName:'Duration(day-time)', field:'',
      cellRenderer: (row: ICellRendererParams) => this.duration(row.data.startTime, row.data.endTime)
    },
  ];

  ngOnInit(): void {
    this.gridOptions = AgGridService.getOptions();
    this.title.emit('Loading Time');
    forkJoin([
      this._organisationService.getPorts(),
      this._vesselsService.getActiveVessels(),
      this._lookupServiceSpa.getLookupItems({categoryName: 'voyage_sof_all'})
    ]).subscribe(item => {
      this.ports = item[0];
      this.vessels = item[1];
      this.lookUpSofItems = item[2].items.flatMap((lookupItem: any) => lookupItem.values);
      this.fillDataTable();
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  fillDataTable() {
    this._settings = this._userLocalStorage.get<SOFComponentSettings>('SOFItemComponent');
    if (this._settings === null) {
      this._settings = {
        type: 'loading',
        sofItem1: 'L01011', sofItem2: 'L02051'
      };
    }
    this._type = this._settings.type;
    this.toolbarComponent.type = this._settings.type;
    this.sofItem1 = this._settings.sofItem1;
    this.sofItem2 = this._settings.sofItem2;
    if (!this.startDate && !this.endDate) {
      this.startDate = this.dateRange.startDate.getTime();
      this.endDate = this.dateRange.endDate.getTime();
    }
    this.getSof(this.startDate, this.endDate, this._type, this.sofItem1, this.sofItem2);
    this.lookUpSofItems.map(f => {
      const code = f[0];
      const name = f[1];
      const des = f[2];
      if (this._settings.sofItem1 === code) {
        this.sofName1 = name.substring(0, 20);
        this.toolTip1 = name;
        this.toolbarComponent.extraSofEntry = [code, name, des];
      }
      if (this._settings.sofItem2 === code) {
        this.sofName2 = name.substring(0, 20);
        this.toolTip2 = name;
        this.toolbarComponent.extraSofEntry2 = [code, name, des];
      }
    });
    this.toolbarComponent.itemsSelected.subscribe(t => {
      this.refresh(t);
    });
  }

  getSof(startDate: number, endDate: number, type: string, item1: string, item2: string) {
    this._vesselsService.getSOFDuration(startDate, endDate,
      type, item1, item2).subscribe(s => {
      this.sofItems = [];
      this.sofItems = s;
    });
  }

  duration(start: number, end: number) {
    if (start && end) {
      const d = end - start;
      if(d > 0) {
        return moment.duration(d).days() + '-' + moment.duration(d).hours() + ':' + moment.duration(d).minutes();
      } else {
        return 'Error';
      }
    } else {
      return '';
    }
  }

  refresh(item: ToolbarItem) {
    this._settings = {
      type: item.type,
      sofItem1: item.firstSOF,
      sofItem2: item.secondeSOF,
    };
    this.startDate = item.dateRange.startDate.getTime();
    this.endDate = item.dateRange.endDate.getTime();
    this._userLocalStorage.save('SOFItemComponent', this._settings);
    this.fillDataTable();
  }

  dateTime(id: string, timestamp: number) {
    const port = this.ports.find(p => p.name === id);
    if (port && timestamp) {
      return DateTimeHelpers.getDateTimeFromTimestamp(port.timezone, timestamp);
    }
  }

  formatPorts(portOrganisationId: string) {
    if (this.ports) {
      const port = this.ports.find(p => p.name === portOrganisationId);
      return (port !== undefined) ? port.nameTranslations['en'] : '';
    }
  }

  excelExport() {
    this._vesselsService.getSOFDurationExcel(this.startDate, this.endDate
      , this._type, this.sofItem1, this.sofItem2).subscribe(file => {
      const t = DateTimeHelpers.formatLocalDate(this.endDate);
      saveAs(file.body!, `Loading Time ${t}.xlsx`);
    });
  }

}
